import {
    STATUS_TYPE,
    validityOptions,
} from '../../../utils/constants/commonValues';
import moment from 'moment';

function PaySummary(data) {
    const values = data && data.summaryData;
    return (values && this.createRow(values)) || {};
}

PaySummary.prototype = Object.assign(PaySummary.prototype, {
    createRow(row) {
        const {
            amount,
            createdBy,
            createdOn,
            editedBy,
            editedOn,
            linkDataId,
            linkDataStatus,
            linkId,
            linkName,
            remarks,
            sharedCount,
            txnSuccessCount,
            validityPeriod,
        } = row;
        return {
            amount: amount || '-',
            createdBy: createdBy || '-',
            createdOn: this.convertDate(createdOn),
            editedBy: editedBy || '-',
            editedOn: this.convertDate(editedOn),
            linkDataId: linkDataId || '-',
            linkDataStatus: this.getTransactionStatus(linkDataStatus),
            linkId: linkId || '-',
            linkName: linkName || '-',
            remarks: remarks || '-',
            sharedCount: sharedCount || '-',
            txnSuccessCount: txnSuccessCount || '-',
            validityPeriod: this.getValidity(validityPeriod),
        };
    },
    getTransactionStatus(status) {
        if (!status) {
            return '-';
        }
        return STATUS_TYPE[status];
    },
    getValidity(validityPeriod) {
        if (!validityPeriod) {
            return '-';
        }
        const values = validityOptions.filter(
            item => item.value === validityPeriod
        );
        return (values && values.length && values[0].name) || '-';
    },
    convertDate(date) {
        const dateFormat = parseInt(date, 10);
        const dateString = moment(dateFormat).format('DD/MM/YYYY');
        return dateString;
    },
});

export default PaySummary;
